import type { FunctionComponent } from 'react';
import { forwardRef } from 'react';
import { Link, type LinkProps } from 'react-router-dom';

import { getBaseUrl } from '../../../keycloak/utils/get-base-url';
import { addContextToUrl } from '../../hooks/use-context-navigate';
import { useHrefBuilder } from '../../hooks/use-href';
import { useKeycloakContext } from '../../hooks/use-keycloak-context';
import { pathToUrl } from '../../utils/path';

export const ContextLink: FunctionComponent<
    LinkProps & {
        rawHref?: boolean;
        targetBlank?: boolean;
    } & React.RefAttributes<HTMLAnchorElement>
> = forwardRef(({ to, targetBlank = false, rawHref = false, ...restProps }, ref) => {
    const isKeycloakContext = useKeycloakContext();
    const hrefBuilder = useHrefBuilder();
    const link = addContextToUrl(to, hrefBuilder);

    if (!isKeycloakContext && !rawHref) {
        return <Link ref={ref} to={link} {...restProps} />;
    }

    const url = rawHref ? pathToUrl(to) : `${getBaseUrl()}${pathToUrl(link)}`;

    return <a target={targetBlank ? '_blank' : ''} rel="noreferrer" {...restProps} href={url} />;
});
